import { useTranslation } from "react-i18next";

export default function ContactHero() {
  const { t } = useTranslation("home");

  return (
    <section className="w-full bg-white py-4 md:py-6 lg:py-8">
      <div className="w-full max-w-[1100px] mx-auto">
        <div className="relative w-full h-[320px] md:h-[420px] lg:h-[500px] overflow-hidden">
          <img loading="lazy"
            src="https://net-basis.net/Bilder/netbasis-contact-duesseldorf-dach.webp"
            alt={t("contactPage.hero.heroAlt")}
            title={t("contactPage.hero.title")}
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
          <div className="absolute inset-0 z-20 flex flex-col items-start justify-center px-6 md:px-10 pointer-events-none">
            <div className="flex flex-col items-center -translate-y-[18px] md:translate-x-[75px] md:-translate-y-[20px] lg:-translate-y-[15px] lg:translate-x-[60px]">
              <p
                className="text-3xl md:text-4xl lg:text-5xl font-normal text-white drop-shadow-[0_1px_4px_rgba(0,0,0,0.6)] text-left md:text-center animate-[bdTextSlide_12s_ease-in-out_infinite]"
                style={{ fontFamily: '"Open Sans", sans-serif', paddingRight: '0.5rem' }}
              >
                <span className="block">{t("contactPage.hero.title")}</span>
                <span className="block md:mt-3">{t("contactPage.hero.subtitle")}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}